import api from './api';

class AnalyticsService {
    dailyCollectionsReport(dataForm) {
        return api.post('/merchant/analytics/daily-collections', dataForm);
    }

    collectionByBranchReport(dataForm) {
        return api.post('/merchant/analytics/collection-by-branch', dataForm);
    }

    ItemSalesByReceiptReport(dataForm) {
        return api.post('/merchant/analytics/items-by-receipt', dataForm);
    }

    itemSalesReport(dataForm) {
        return api.post('/merchant/analytics/item-sales', dataForm);
    }

    itemSalesWithModifiersReport(dataForm) {
        return api.post('/merchant/analytics/item-sales-with-modifiers', dataForm);
    }

    hourlySalesReport(dataForm) {
        return api.post('/merchant/analytics/hourly-sales-report', dataForm);
    }

    pricingAnalysisReport(dataForm) {
        return api.post('/merchant/analytics/pricing-analysis', dataForm);
    }

    staffClockInOutReport(dataForm) {
        return api.post('/merchant/analytics/staff-clock-in-out', dataForm);
    }

    commissionReport(dataForm) {
        return api.post('/merchant/analytics/commission-report', dataForm);
    }

    serviceCommissionReport(dataForm) {
        return api.post('/merchant/analytics/service-commission', dataForm);
    }

    productCommissionReport(dataForm) {
        return api.post('/merchant/analytics/product-commission', dataForm);
    }

    itemDetailsByChannelReport(dataForm) {
        return api.post('/merchant/analytics/items-by-channel', dataForm);
    }

    recipeUsageReport(dataForm) {
        return api.post('/merchant/analytics/recipe-usage', dataForm);
    }

    itemSalesByPriceReport(dataForm) {
        return api.post('/merchant/analytics/item-sales-by-price', dataForm);
    }

    productionReport(dataForm) {
        return api.post('/merchant/analytics/production-report', dataForm);
    }

    itemSalesModifiersReport(dataForm) {
        return api.post('/merchant/analytics/item-sales-modifiers', dataForm);
    }

    itemDiscountReport(dataForm) {
        return api.post('/merchant/report/item-discount-report', dataForm);
    }

    billDiscountReport(dataForm) {
        return api.post('/merchant/report/bill-discount-report', dataForm);
    }

    itemFocReport(dataForm) {
        return api.post('/merchant/report/item-foc-report', dataForm);
    }

    billFocReport(dataForm) {
        return api.post('/merchant/report/bill-foc-report', dataForm);
    }

    billVoidedReport(dataForm) {
        return api.post('/merchant/report/bill-voided-report', dataForm);
    }

    itemVoidedReport(dataForm) {
        return api.post('/merchant/report/item-voided-report', dataForm);
    }

    itemSalesModifiersReportNew(dataForm) {
        return api.post('/merchant/analytics/item-sales-modifiers-new', dataForm);
    }

    posDailyCollectionsReport(dataForm) {
        return api.post('/merchant/analytics/pos-daily-collections', dataForm);
    }

    itemSalesByGroupDailyReport(dataForm) {
        return api.post('/merchant/analytics/item-sales-by-group-daily', dataForm);
    }

    // Custom Reports. Both hit SalesLineService on the API side, so their
    // figures reconcile with each other.
    dailyRevenueReport(dataForm) {
        return api.post('/merchant/analytics/daily-revenue', dataForm);
    }

    itemSalesDetailReport(dataForm) {
        return api.post('/merchant/analytics/item-sales-detail', dataForm);
    }

    // Report Builder (minty.crm.api docs/api-report-builder.md)
    reportBuilderFields() {
        return api.post('/merchant/analytics/report-builder/fields');
    }

    reportBuilderList() {
        return api.post('/merchant/analytics/report-builder/list');
    }

    reportBuilderDetail(id) {
        return api.post('/merchant/analytics/report-builder/detail', { id });
    }

    reportBuilderSave(dataForm) {
        return api.post(`/merchant/analytics/report-builder/${dataForm.id ? 'update' : 'store'}`, dataForm);
    }

    reportBuilderDelete(id) {
        return api.post('/merchant/analytics/report-builder/delete', { id });
    }

    reportBuilderReorder(ids) {
        return api.post('/merchant/analytics/report-builder/reorder', { ids });
    }

    reportBuilderRun(dataForm, config = {}) {
        return api.post('/merchant/analytics/report-builder/run', dataForm, config);
    }

    erpCollectionsReport(dataForm) {
        return api.post('/merchant/analytics/erp-collections', dataForm);
    }

    exportErpCollections(dataForm) {
        return api.post('/merchant/analytics/erp-collections/export', dataForm, {
            responseType: 'blob'
        });
    }

    erpDetail(id) {
        return api.post('/merchant/analytics/erp/detail/' + id);
    }

    updateErp(dataForm) {
        return api.post('/merchant/analytics/erp/update', dataForm);
    }

    saveDraft(dataForm) {
        return api.post('/merchant/analytics/erp/save-draft', dataForm);
    }

    uploadErp(dataForm) {
        return api.post('/merchant/analytics/erp/upload', dataForm);
    }

    deleteErp(id) {
        return api.post('/merchant/analytics/erp/delete/' + id);
    }

    getLoginCredentials() {
        return api.get('/merchant/analytics/erp/get-login-credentials');
    }

    uploadXeroErp(dataForm) {
        return api.post('/merchant/analytics/erp/xero-upload', dataForm);
    }
    saveLoginCredentials(dataForm) {
        return api.post('/merchant/analytics/erp/save-login-credentials', dataForm);
    }

    saveXeroLoginCredentials(dataForm) {
        return api.post('/merchant/analytics/erp/xero/save-login-credentials', dataForm);
    }

    saveQuickbooksLoginCredentials(dataForm) {
        return api.post('/merchant/analytics/erp/quickbooks/save-login-credentials', dataForm);
    }

    erpUploadResponse(id, dataForm) {
        return api.post('/merchant/analytics/erp/' + id + '/upload-response', dataForm);
    }

    getMetaEmbed(dataForm) {
        return api.post('/merchant/metabase-embed', dataForm);
    }

    getFilterData(dataForm) {
        return api.post('/merchant/analytics/get-filter-data', dataForm);
    }

    postAuthCodes(dataForm) {
        return api.post('/merchant/analytics/erp/xero/post-auth-codes', dataForm);
    }

    postQuickbooksAuthCodes(dataForm) {
        return api.post('/merchant/analytics/erp/quickbooks/post-auth-codes', dataForm);
    }

    uploadQuickbooksErp(dataForm) {
        return api.post('/merchant/analytics/erp/quickbooks-upload', dataForm);
    }
}

export default new AnalyticsService();